import { connect } from 'react-redux';
import { getVerificationLoadingState } from '../publicSession/selectors';
import { updateEmail } from '../publicSession/actions';
var mapStateToProps = function (state) {
    return getVerificationLoadingState(state);
};
var mapDispatchToProps = {
    changeEmail: updateEmail,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=VerificationEmailInput.container.js.map